import 'chartjs-adapter-moment';
import React, { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { IPen } from 'shared/api/api';
import { sortByOrder } from 'shared/helpers/location-helper';
import { TextWeb } from 'web/web-helpers/styled-text-components';
import { localized } from '../../../../../../shared/state/i18n/i18n';
import { WebAppState } from '../../../../../state/store.web';
import { useGpeDashboard } from '../../../../pages/dashboard-overview-growth-pigs/dashboard-overview-growth-pigs';
import { ViewWeb } from '../../../utils/web-view';
import './feed-usage-graph.scss';
import leftArrow from 'shared/assets/src-assets/svg/left_arrow.svg';
import rightArrow from 'shared/assets/src-assets/svg/right_arrow.svg';
import { SkioldTouchableOpacity } from '../../../skiold-components/skiold-touchable-opacity';
import { SkioldImage } from '../../../utils/svg/skiold-image';

export const FeedUsagePenSlider: FC = React.memo(() => {
	const { sectionId, penId, setPenId } = useGpeDashboard();
	const pens = useSelector((state: WebAppState) => state.locations.pens);

	const pensInSection = useMemo(() => {
		return sortByOrder(pens.filter(p => p.sectionId === sectionId)) as IPen[];
	}, [pens, sectionId]);

	const index = useMemo(() => {
		if (pensInSection && penId) {
			return pensInSection.findIndex(p => p.id === penId);
		}
		return -1;
	}, [pensInSection, penId]);

	const prevPen = () => {
		if (index > 0) {
			setPenId(pensInSection[index - 1].id);
		} else if (index === 0) {
			setPenId(undefined);
		}
	};

	const nextPen = () => {
		if (index < pensInSection.length - 1) {
			setPenId(pensInSection[index + 1].id);
		}
	};

	return (
		<ViewWeb className="feed-usage-slider">
			<SkioldTouchableOpacity onPress={prevPen}>
				<SkioldImage
					imageData={leftArrow}
					className={`slider-arrow ${penId === undefined ? 'disabled' : ''}`}
				/>
			</SkioldTouchableOpacity>
			<TextWeb className="slider-text">{localized('pen')}: </TextWeb>
			{pensInSection[index]?.name && (
				<TextWeb className="pen-text">{pensInSection[index]?.name ? pensInSection[index]?.name : ''}</TextWeb>
			)}
			<SkioldTouchableOpacity onPress={nextPen}>
				<SkioldImage
					imageData={rightArrow}
					className={`slider-arrow ${index === pensInSection.length - 1 ? 'disabled' : ''}`}
				/>
			</SkioldTouchableOpacity>
		</ViewWeb>
	);
});
